// @flow

import React from 'react'
import styled, { css } from 'styled-components'
import Colors from 'components/styles/colors'
import { mediaMin, mediaMax } from 'frontend_core/dist/styles/media'
import { spacing, fontSize } from 'frontend_core/dist/styles/variables'
import Button from 'components/atoms/Button'
import Modal from 'components/molecules/Modal'

const ModalSelectTitle = styled.h2`
  color: ${Colors.black};
  text-align: center;
  font-size: ${fontSize.medium_2}px;
  font-weight: bold;
  ${mediaMin.phone`
    font-size: ${fontSize.large_2}px;
  `};
`

const ModalSelectText = styled.p`
  text-align: center;
  margin-top: ${spacing.small_3}px;
  color: ${Colors.gray9};
  font-size: 12px;
  line-height: 1.477;
`

const ButtonWrapper = styled.div`
  max-width: 400px;
  margin: ${spacing.medium_2}px auto 0;
  ${mediaMin.phone`
    margin-top: ${spacing.large}px;
  `};
  ${props =>
    props.isButtonTwoBlock &&
    css`
      ${mediaMax.phone`
      display: flex;
      flex-direction: column-reverse;
    `};
    `};
`

const ButtonContainer = styled.div`
  display: inline-block;
  width: 50%;
  &:nth-child(2n) {
    padding: 0 0 0 ${spacing.small / 2}px;
  }
  &:nth-child(2n-1) {
    padding: 0 ${spacing.small / 2}px 0 0;
  }
  ${mediaMin.phone`
    &:nth-child(2n) {
      padding: 0 0 0 ${spacing.small}px;
    }
    &:nth-child(2n-1) {
      padding: 0 ${spacing.small}px 0 0;
    }
  `};
  ${props =>
    props.isButtonTwoBlock &&
    css`
      ${mediaMax.phone`
        display: block;
        width: 100%;
        &:nth-child(2n) {
          padding: 0;
        }
        &:nth-child(2n-1) {
          padding: 0;
        }
        &:not(:first-child) {
          margin-bottom: ${spacing.small_2}px;
        }
       `};
    `};
`

const ButtonColumnReverse = styled.div`
  ${mediaMax.phone`
    display: flex;
    flex-direction: column-reverse;
  `};
`
const ButtonColumnReverseItem = styled.div`
  ${mediaMin.phone`
    display: inline-block;
    width: 197px;
  `};
  &:not(:first-child) {
    margin: 0 0 ${spacing.small_2}px 0;
    ${mediaMin.phone`
      margin: 0 0 0 ${spacing.small_2}px;
    `};
  }
`
const AttentionText = styled.p`
  font-size: 11px;
  color: #999;
  line-height: 1.5;
  margin-top: 8px;
`

export type PropTypes = {
  title: string,
  textList: Array<string> | string,
  positiveButton: {
    text: string,
    onClick: Function,
  },
  negativeButton: {
    text: string,
    onClick: Function,
  },
  isActive: boolean,
  onClickClose: Function,
  children: any,
  isButtonTwoBlock?: ?boolean,
  attentionText?: ?string,
}

export default class ModalSelect extends React.Component<PropTypes> {
  componentWillUnmount() {
    this.preventBarrage = false
  }

  componentDidUpdate(prevProps: PropTypes) {
    if (!prevProps.isActive && this.props.isActive) {
      this.preventBarrage = false
    }
  }

  preventBarrage: any

  render() {
    const {
      title,
      textList,
      negativeButton,
      positiveButton,
      isActive,
      onClickClose,
      children,
      isButtonTwoBlock,
      attentionText,
    } = this.props

    return (
      <Modal isActive={isActive} onClickClose={onClickClose}>
        <ModalSelectTitle>{title}</ModalSelectTitle>
        <ModalSelectText>
          {textList.map((text, i) => (
            <span key={`dialogContent${i}`}>
              {text}
              {i < textList.length && <br />}
            </span>
          ))}
        </ModalSelectText>
        {children}
        <ButtonWrapper isButtonTwoBlock={isButtonTwoBlock}>
          {negativeButton && (
            <ButtonContainer isButtonTwoBlock={isButtonTwoBlock}>
              <Button
                onClick={negativeButton.onClick}
                buttonType="medium"
                tag="button"
                colorType="gray"
                fullWidthSp
                fullWidthPc
              >
                {negativeButton.text}
              </Button>
            </ButtonContainer>
          )}
          {positiveButton && (
            <ButtonContainer isButtonTwoBlock={isButtonTwoBlock}>
              <Button
                onClick={() => {
                  if (!this.preventBarrage && positiveButton.onClick) {
                    this.preventBarrage = true
                    positiveButton.onClick()
                  }
                }}
                buttonType="medium"
                tag="button"
                colorType="blue"
                fullWidthSp
                fullWidthPc
              >
                {positiveButton.text}
              </Button>
            </ButtonContainer>
          )}
        </ButtonWrapper>
        {attentionText && <AttentionText>{attentionText}</AttentionText>}
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/organisms/ModalSelect/index.jsx